<div #energymonitorChart style="text-align:center">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple"
    [fullScreen]="false" name="live-energymonitor"></ngx-spinner>
  <svg style.width="{{ width }}px" style.height="{{ height }}px" overflow="visible">
    <!-- !graphic -->
    <svg:g [attr.transform]="translation">
      <svg:g consumptionsection></svg:g>
      <svg:g gridsection></svg:g>
      <svg:g productionsection></svg:g>
      <svg:g storagesection></svg:g>
    </svg:g>
  </svg>
</div>
